
document.addEventListener("DOMContentLoaded", function () {
  const rotatingWrapper = document.getElementById("cstm-rotating-text");
  const circleText = document.getElementById("circleText");

  function updateRotatingText(value) {
    if (value === "50-pack") {
      circleText.textContent = "BEST • SELLER •";
      circleText.setAttribute("fill", "#fcb61a");
      circleText.setAttribute("letter-spacing", "15px");
      rotatingWrapper.style.display = "block";
    } else if (value === "100-pack") {
      circleText.textContent = "SAVE • MORE •";
      circleText.setAttribute("fill", "green");
      circleText.setAttribute("letter-spacing", "18px");
      rotatingWrapper.style.display = "block";
    } else {
      // for 10-pack or anything else → hide badge + icon
      rotatingWrapper.style.display = "none";
    }
  }

  // 🔹 Hide badge + icon by default
  rotatingWrapper.style.display = "none";

  // Event delegation
  document.addEventListener("change", function (e) {
    if (e.target.matches("ul.swatches input[type='radio']")) {
      updateRotatingText(e.target.value);
    }
  });
});



document.addEventListener("DOMContentLoaded", function() {
  const iframe = document.querySelector('iframe');
  const playBtn = document.querySelector('.deferred-poster');

  if (iframe && playBtn) {
    // Button click → video play + hide button
    playBtn.addEventListener('click', function () {
      iframe.contentWindow.postMessage(
        '{"event":"command","func":"playVideo","args":""}',
        '*'
      );
      playBtn.style.display = "none";
    });

    // Listen for YouTube state changes
    window.addEventListener('message', function (event) {
      try {
        const data = JSON.parse(event.data);

        if (data.event === "infoDelivery" && data.info) {
          // 2 = paused → show button
          if (data.info.playerState === 2) {
            playBtn.style.display = "block";
          }
          // 1 = playing → hide button
          if (data.info.playerState === 1) {
            playBtn.style.display = "none";
          }
        }
      } catch (e) {
        // ignore non-JSON messages
      }
    });
  }
});





document.addEventListener("DOMContentLoaded", function () {

  const videos = document.querySelectorAll("video");

  videos.forEach(video => {
    video.addEventListener("click", function () {
      video.muted = false;     // always unmute
      video.volume = 1.0;      // full volume
      video.play();            // play after click
    });
  });





















});


